import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const SdkDebuggerSessionTable = lazy(() =>
  import("@scenes/SDKDebugger/components/SdkDebuggerSessionTable/").then((module) => ({
    default: module.SdkDebuggerSessionTable,
  }))
);

export const sdkDebuggerNRO: NavigationRoutingObject = {
  Component: SdkDebuggerSessionTable,
  componentFeatureFlippers: ["sdk_debugger"],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("sdk-debugger-nro-heading", "SDK Debugger"),
  pageNameForTracking: () => "SDK Debugger",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const hasViewPermission = hasPermission("appGroup", { permission: "viewSdkDebugger" });
    return featureOn("sdk_debugger") && hasViewPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
